export default __webpack_public_path__ + "static/soda1-ba7800208c7140c36e0396c04b43cedc.png";